module.exports = __webpack_public_path__ + "img/all-logo.c5fad265.png";